import { create } from 'zustand';

// 属性面板固定导航顺序：对象 → 几何 → 材质
export const PROPERTY_PANEL_ORDER = ['object', 'geometry', 'material'] as const;
export type PropertyPanelKey = (typeof PROPERTY_PANEL_ORDER)[number];

interface PropertyPanelState {
  activePanel: string | null;
  setActivePanel: (panel: string | null) => void;
  goBack: () => void;
  goForward: () => void;
  canGoBack: () => boolean;
  canGoForward: () => boolean;
}

// 当前面板在顺序中的索引；null 视为第一个（对象），顺序外视为边界外
function indexOfPanel(panel: string | null): number {
  if (panel === null) return 0;
  return PROPERTY_PANEL_ORDER.indexOf(panel as PropertyPanelKey);
}

const usePropertyPanel = create<PropertyPanelState>((set, get) => ({
  activePanel: null,

  setActivePanel: (panel) => set({ activePanel: panel }),

  // 顺序导航：向左/右移动到固定序列中的相邻面板
  goBack: () => {
    const state = get();
    const idx = indexOfPanel(state.activePanel);
    if (idx > 0) {
      set({ activePanel: PROPERTY_PANEL_ORDER[idx - 1] });
    }
  },

  goForward: () => {
    const state = get();
    const idx = indexOfPanel(state.activePanel);
    if (idx >= 0 && idx < PROPERTY_PANEL_ORDER.length - 1) {
      set({ activePanel: PROPERTY_PANEL_ORDER[idx + 1] });
    }
  },

  canGoBack: () => {
    return indexOfPanel(get().activePanel) > 0;
  },

  canGoForward: () => {
    const idx = indexOfPanel(get().activePanel);
    return idx >= 0 && idx < PROPERTY_PANEL_ORDER.length - 1;
  },
}));

export default usePropertyPanel;
